import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/home/gitlab-runner/builds/DYLxiz_xJ/0/gemeente-vught/website-speeldoos-nuxt/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-TQRPRKB4"})
    return { provide: { $scripts: { googleTagManager } } }
  }
})